export const base = import.meta.env.BASE_URL;
export const name = import.meta.env.VITE_NAME;
export const version = import.meta.env.VITE_VERSION;
export const description = import.meta.env.VITE_DESCRIPTION;
export const api = import.meta.env.VITE_API;
